import { ChangeDetectionStrategy, Component, inject, Input, SimpleChanges } from '@angular/core';
import { UnaryFunction } from '@dice/app/types/dice.types';
import { TranslateService } from '@ngx-translate/core';
import { get as _get } from 'lodash';

@Component({
  selector: 'table-column-prerendered-text',
  templateUrl: './table-column-prerendered-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableColumnPrerenderedTextComponent<T> {
  private translateService = inject(TranslateService);

  @Input() cssClass?: string;

  @Input() displayValue?: UnaryFunction<T, string> | string;

  @Input() element: T;

  @Input() translation: string;

  @Input() tooltip?: string | UnaryFunction<T, string>;

  static readonly sortEnabled = true;

  displayedText: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    const { translation, element, tooltip } = changes;
    if (translation || element) {
      this.displayContent();
    }
    if (tooltip && typeof this.tooltip === 'function') {
      const getTooltip = this.tooltip;
      this.tooltip = getTooltip(this.element);
    }
  }

  displayContent(): void {
    if (this.translation) {
      this.displayedText = this.translateService.instant(this.translation);
    }
    if (typeof this.displayValue === 'string') {
      this.displayedText = _get(this.element, this.displayValue);
    }
    if (typeof this.displayValue === 'function') {
      this.displayedText = this.displayValue(this.element);
    }
  }
}
